<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar id="clickArea">
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{name: item.name, icon: item.icon, path: item.path}"
          v-bind:key="item.name"
          v-for="item in menu"
        >
          <sidebar-item
            v-for="subItem in item.children"
            :link="{name: subItem.name, icon: subItem.icon, path: subItem.path}"
            v-bind:key="subItem.name"
          ></sidebar-item>
        </sidebar-item>

        <!-- <sidebar-item :link="{name: 'Summary', icon: 'now-ui-icons design_image'}">
          <sidebar-item :link="{name: 'Order List', path: '/summary/orders'}"></sidebar-item>
        </sidebar-item>-->
      </template>
      <!-- <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{name: '營業統計', icon: 'now-ui-icons business_chart-pie-36', path: '/charts'}"
        ></sidebar-item>
        <sidebar-item :link="{name: '用戶管理', icon: 'now-ui-icons education_atom'}">
          <sidebar-item :link="{name: 'SI管理', path: '/components/buttons'}"></sidebar-item>
        </sidebar-item>
      </template>-->
      <!-- <template slot-scope="props" slot="links">
        <user-menu></user-menu>
        <sidebar-item :link="{name: 'Dashboard', icon: 'now-ui-icons design_app', path: '/dashboard'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'Pages', icon: 'now-ui-icons design_image'}">
          <sidebar-item :link="{name: 'Pricing', path: '/pricing'}"></sidebar-item>
          <sidebar-item :link="{name: 'Timeline', path: '/pages/timeline'}"></sidebar-item>
          <sidebar-item :link="{name: 'Login', path: '/login'}"></sidebar-item>
          <sidebar-item :link="{name: 'Register', path: '/register'}"></sidebar-item>
          <sidebar-item :link="{name: 'Lock Screen', path: '/lock'}"></sidebar-item>
          <sidebar-item :link="{name: 'User Profile', path: '/pages/user'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Components', icon: 'now-ui-icons education_atom'}">
          <sidebar-item :link="{name: 'Buttons', path: '/components/buttons'}"></sidebar-item>
          <sidebar-item :link="{name: 'Grid System', path: '/components/grid-system'}"></sidebar-item>
          <sidebar-item :link="{name: 'Panels', path: '/components/panels'}"></sidebar-item>
          <sidebar-item :link="{name: 'Sweet Alert', path: '/components/sweet-alert'}"></sidebar-item>
          <sidebar-item :link="{name: 'Notifications', path: '/components/notifications'}"></sidebar-item>
          <sidebar-item :link="{name: 'Icons', path: '/components/icons'}"></sidebar-item>
          <sidebar-item :link="{name: 'Typography', path: '/components/typography'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Forms', icon: 'now-ui-icons files_single-copy-04'}">
          <sidebar-item :link="{name: 'Regular Forms', path: '/forms/regular'}"></sidebar-item>
          <sidebar-item :link="{name: 'Extended Forms', path: '/forms/extended'}"></sidebar-item>
          <sidebar-item :link="{name: 'Validation Forms', path: '/forms/validation'}"></sidebar-item>
          <sidebar-item :link="{name: 'Wizard', path: '/forms/wizard'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Tables', icon: 'now-ui-icons design_bullet-list-67'}">
          <sidebar-item :link="{name: 'Regular Tables', path: '/table-list/regular'}"></sidebar-item>
          <sidebar-item :link="{name: 'Extended Tables', path: '/table-list/extended'}"></sidebar-item>
          <sidebar-item :link="{name: 'Paginated Tables', path: '/table-list/paginated'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Maps', icon: 'now-ui-icons location_pin'}">
          <sidebar-item :link="{name: 'Google Maps', path: '/maps/google'}"></sidebar-item>
          <sidebar-item :link="{name: 'Full Screen Maps', path: '/maps/full-screen'}"></sidebar-item>
          <sidebar-item :link="{name: 'Vector Maps', path: '/maps/vector-map'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{name: 'Widgets', icon: 'now-ui-icons objects_diamond', path: '/widgets'}"></sidebar-item>
        <sidebar-item
          :link="{name: 'Charts', icon: 'now-ui-icons business_chart-pie-36', path: '/charts'}"></sidebar-item>
        <sidebar-item
          :link="{name: 'Calendar', icon: 'now-ui-icons media-1_album', path: '/calendar'}"></sidebar-item>

      </template>-->
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <router-view name="header"></router-view>

      <div :class="{content: !$route.meta.hideContent}" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { SlideYDownTransition, ZoomCenterTransition } from "vue2-transitions";
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      menu: [],
      clickTimes: 0
    };
  },
  computed: {
    ...mapGetters([
      'appLang',
    ]),
    userType: function() {
      return this.$store.getters.userType;
    }
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    UserMenu,
    SlideYDownTransition,
    ZoomCenterTransition
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    appendMenu() {
      let _index = this.menu.findIndex(nameObj => {
        return nameObj.name == "其它工具";
      });
      if(_index == -1) {
        this.menu.push({
          name: "其它工具",
          icon: "now-ui-icons ui-2_settings-90",
          path: "/",
          children: [
            {
              name: "LINE SPOT管理",
              path: "/other/line-spot"
            },
            {
              name: "LINE Module管理",
              path: "/other/line-module"
            },
            {
              name: "商店設定概覽、測試工具",
              path: "/other/developer-tool"
            },
            {
              name: "分站出單",
              path: "/other/printer/stations"
            },
            {
              name: "雲市集資料匯入",
              path: '/other/cloud-market'
            },
            {
              name: "WEB2.0會員查詢",
              path: '/other/member'
            }
          ]
        });
      }
    },
    clickCounter() {
      let that = this;
      document.getElementById("clickArea").addEventListener("click", function( event ) {
        // 在 “clicked div”顯示點擊次數
        if(event.detail == 10) that.appendMenu();
      }, false);
    },
    generateSiMenu() {
      return [
          {
            name: this.$t("Sidebar.SI.Business_Overview.Name"),
            icon: "now-ui-icons business_chart-pie-36",
            path: "/summary",
            children: [
              {
                name: this.$t("Sidebar.SI.Business_Overview.Overview"),
                icon: "el-icon-data-analysis",
                path: "/summary/stat"
              },
              {
                name: this.$t("Sidebar.SI.Business_Overview.Order_List"),
                icon: "now-ui-icons files_paper",
                path: "/summary/orders"
              },
              {
                name: this.$t("Sidebar.SI.Business_Overview.Store_Reports"),
                icon: "el-icon-data-line",
                path: "/summary/shop-stat"
              }
            ]
          },
          {
            name: this.$t("Sidebar.SI.Store_Management.Name"),
            icon: "now-ui-icons shopping_shop",
            path: "",
            children: [
              {
                name: this.$t("Sidebar.SI.Store_Management.Store_Management_Beta"),
                icon: "el-icon-suitcase",
                path: "/si/settings"
              },
              {
                name: this.$t("Sidebar.SI.Store_Management.Store_Management"),
                icon: "el-icon-suitcase",
                path: "/si/business"
              },
              {
                name: this.$t("Sidebar.SI.Store_Management.Menu_Management"),
                icon: "el-icon-reading",
                path: "/menu-management"
              },
              {
                name: this.$t("Sidebar.SI.Store_Management.New_Menu_Management_Beta"),
                icon: "el-icon-reading",
                path: "/newmenu-management"
              },
              {
                name: this.$t("Sidebar.SI.Store_Management.Sales_Inquiry"),
                icon: "el-icon-shopping-cart-full",
                path: "/sales/query"
              },
              // {
              //   name: "餐券＆寄杯",
              //   icon: "el-icon-coffee",
              //   path: "/sales/vouchers"
              // },
              // {
              //   name: "360營業報告",
              //   icon: "now-ui-icons education_atom",
              //   path: "/report/360-stats"
              // }
            ]
          },
          {
            name: this.$t("Sidebar.SI.Marketing_Activities.Name"),
            icon: "el-icon-present",
            path: "",
            children: [
              {
                name: this.$t("Sidebar.SI.Marketing_Activities.Send_Coupons"),
                icon: "el-icon-discount",
                path: "/send-coupons"
              }
            ]
          },
          {
            name: this.$t("Sidebar.SI.User_Management.Name"),
            icon: "now-ui-icons users_single-02",
            path: "/",
            children: [
              {
                name: this.$t("Sidebar.SI.User_Management.Administrator_List"),
                path: "/si-users"
              },
              {
                name: this.$t("Sidebar.SI.User_Management.Store_Account_Management"),
                path: "/eaa-accounts"
              }
              // {
              //   name: "User 帳戶管理",
              //   path: "/users"
              // }
            ]
          },
          // {
          //   name: this.$t("Sidebar.SI.Login_Management.Name"),
          //   icon: "now-ui-icons users_single-02",
          //   path: "/",
          //   children: [
          //     {
          //       name: this.$t("Sidebar.SI.Login_Management.Login_Record"),
          //       path: "/si-login-record"
          //     }
          //   ]
          // }
        ]
    },
    generateGaaMenu() {
      return [
          {
            name: this.$t("Sidebar.GAA.Business_Overview.Name"),
            icon: "now-ui-icons business_chart-pie-36",
            path: "/summary",
            children: [
              {
                name: this.$t("Sidebar.GAA.Business_Overview.Overview"),
                icon: "el-icon-data-analysis",
                path: "/summary/stat"
              },
              {
                name: this.$t("Sidebar.GAA.Business_Overview.Order_List"),
                icon: "now-ui-icons files_paper",
                path: "/summary/orders"
              },
              {
                name: this.$t("Sidebar.GAA.Business_Overview.Store_Reports"),
                icon: "el-icon-data-line",
                path: "/summary/shop-stat"
              }
            ]
          },
          {
            name: this.$t("Sidebar.GAA.Store_Management.Name"),
            icon: "now-ui-icons shopping_shop",
            path: "",
            children: [
              {
                name: this.$t("Sidebar.GAA.Store_Management.Store_Management_Beta"),
                icon: "el-icon-suitcase",
                path: "/gaa/settings"
              },
              {
                name: this.$t("Sidebar.GAA.Store_Management.Store_Management"),
                icon: "el-icon-suitcase",
                path: "/gaa/business"
              },
              {
                name: this.$t("Sidebar.GAA.Store_Management.Menu_Management"),
                icon: "el-icon-reading",
                path: "/menu-management"
              },
              {
                name: this.$t("Sidebar.GAA.Store_Management.New_Menu_Management_Beta"),
                icon: "el-icon-reading",
                path: "/newmenu-management"
              },
              {
                name: this.$t("Sidebar.GAA.Store_Management.Sales_Inquiry"),
                icon: "el-icon-shopping-cart-full",
                path: "/sales/query"
              },
              // {
              //   name: "餐券＆寄杯",
              //   icon: "el-icon-coffee",
              //   path: "/sales/vouchers"
              // },
              {
                name: this.$t("Sidebar.GAA.Store_Management.Block_List"),
                icon: "el-icon-remove-outline",
                path: "/sales/banned-list"
              },
              {
                name: this.$t("Sidebar.GAA.Store_Management.Printer_Management"),
                icon: "el-icon-printer",
                path: "/printers/list"
              },
              {
                name: this.$t("Sidebar.GAA.Store_Management.Auto_Report_Store_Settings"),
                icon: "el-icon-message",
                path: "/report/shop-settings"
              },
              {
                name: this.$t("Sidebar.GAA.Store_Management.Rate_Formula_Management"),
                icon: "el-icon-set-up",
                path: "/report/formulas"
              },
              {
                name: this.$t("Sidebar.GAA.Store_Management.Online_Payment_Service"),
                icon: "el-icon-bank-card",
                path: "/report/online-payment-configs"
              },
              {
                name: this.$t("Sidebar.GAA.Store_Management.Application_Management"),
                icon: "el-icon-connection",
                path: "/extra/app-mngmt"
              },
              {
                name: this.$t("Sidebar.GAA.Store_Management.360_Business_Report"),
                icon: "now-ui-icons education_atom",
                path: "/report/360-stats"
              },
              {
              name: this.$t("Sidebar.GAA.Store_Management.Foodpanda_Menu_Management"),
              icon: "el-icon-reading",
              path: "/foodpanda-menu-management",
              },
            ]
          },
          {
            name: this.$t("Sidebar.GAA.VAS_Management.Name"),
            icon: "el-icon-coin",
            path: "",
            children: [
              {
                name: this.$t("Sidebar.GAA.VAS_Management.Account_List"),
                icon: "el-icon-s-custom",
                path: "/vas/billing-accounts"
              },
              {
                name: this.$t("Sidebar.GAA.VAS_Management.Deposit_Records"),
                icon: "el-icon-circle-plus-outline",
                path: "/vas/deposit-records"
              },
              {
                name: this.$t("Sidebar.GAA.VAS_Management.Transaction_Records"),
                icon: "el-icon-s-order",
                path: "/vas/transactions"
              }
            ]
          },
          {
            name: this.$t("Sidebar.GAA.Entrance_Management.Name"),
            icon: "el-icon-menu shopping_shop",
            path: "",
            children: [
              {
                name: this.$t("Sidebar.GAA.Entrance_Management.Entrance_List"),
                icon: "el-icon-menu",
                path: "/portals"
              }
            ]
          },
          {
            name: this.$t("Sidebar.GAA.Store_Opening_Application.Name"),
            icon: "el-icon-menu shopping_shop",
            path: "",
            children: [
              {
                name: this.$t("Sidebar.GAA.Store_Opening_Application.Store_Opening_Application_Management"),
                icon: "el-icon-menu",
                path: "/registrations"
              }
            ]
          },
          // {
          //   name: this.$t("Sidebar.GAA.Financial_Accounting_Tools.Name"),
          //   icon: "now-ui-icons business_money-coins",
          //   path: "",
          //   children: [
          //     {
          //       name: this.$t("Sidebar.GAA.Financial_Accounting_Tools.Collection_and_Payment_Bank_Management"),
          //       icon: "now-ui-icons business_bank",
          //       path: "/acct/bank-accounts"
          //     },
          //     {
          //       name: this.$t("Sidebar.GAA.Financial_Accounting_Tools.Checkout_Tools"),
          //       icon: "el-icon-collection",
          //       path: "/acct/billing-tool"
          //     },
          //   ]
          // },
          {
            name: this.$t("Sidebar.GAA.User_Management.Name"),
            icon: "now-ui-icons users_single-02",
            path: "/",
            children: [
              {
                name: this.$t("Sidebar.GAA.User_Management.GAA_Administrators"),
                path: "/gaa-users"
              },
              {
                name: this.$t("Sidebar.GAA.User_Management.SI_Account_Management"),
                path: "/si-accounts"
              },
              {
                name: this.$t("Sidebar.GAA.User_Management.EAA_Account_Management"),
                path: "/eaa-accounts"
              }
              // {
              //   name: "User 帳戶管理",
              //   path: "/users"
              // }
            ]
          },
          {
            name: this.$t("Sidebar.GAA.Login_Management.Name"),
            icon: "now-ui-icons users_single-02",
            path: "/",
            children: [
              {
                name: this.$t("Sidebar.GAA.Login_Management.Login_Record"),
                path: "/gaa-login-record"
              }
            ]
          }
        ]
    },
    generateEaaMenu() {
      return [
          {
            name: this.$t("Sidebar.EAA.Business_Overview.Name"),
            icon: "now-ui-icons business_chart-pie-36",
            path: "/summary",
            children: [
              {
                name: this.$t("Sidebar.EAA.Business_Overview.Overview"),
                icon: "el-icon-data-analysis",
                path: "/summary/stat"
              },
              {
                name: this.$t("Sidebar.EAA.Business_Overview.Order_List"),
                icon: "now-ui-icons files_paper",
                path: "/summary/orders"
              },
              {
                name: this.$t("Sidebar.EAA.Business_Overview.Store_Reports"),
                icon: "el-icon-data-line",
                path: "/summary/shop-stat"
              }
            ]
          },
          {
            name: this.$t("Sidebar.EAA.Store_Management.Name"),
            icon: "now-ui-icons shopping_shop",
            path: "",
            children: [
              {
                name: this.$t("Sidebar.EAA.Store_Management.Store_Management_Beta"),
                icon: "el-icon-suitcase",
                path: "/eaa/settings"
              },
              {
                name: this.$t("Sidebar.EAA.Store_Management.Store_Management"),
                icon: "el-icon-suitcase",
                path: "/eaa/business/shop-management"
              },
              {
                name: this.$t("Sidebar.EAA.Store_Management.Menu_Management"),
                icon: "el-icon-reading",
                path: "/menu-management"
              },
              {
                name: this.$t("Sidebar.EAA.Store_Management.Sales_Inquiry"),
                icon: "el-icon-shopping-cart-full",
                path: "/sales/query"
              },
              // {
              //   name: "餐券＆寄杯",
              //   icon: "el-icon-coffee",
              //   path: "/sales/vouchers"
              // },
              {
                name: this.$t("Sidebar.EAA.Store_Management.Block_List"),
                icon: "el-icon-remove-outline",
                path: "/sales/banned-list"
              },
              {
                name: this.$t("Sidebar.EAA.Store_Management.360_Business_Report"),
                icon: "now-ui-icons education_atom",
                path: "/report/360-stats"
              }
            ]
          },
          {
            name: this.$t("Sidebar.EAA.User_Management.Name"),
            icon: "now-ui-icons users_single-02",
            path: "/",
            children: [
              {
                name: this.$t("Sidebar.EAA.User_Management.Account_Management"),
                path: "/eaa-account"
              }
            ]
          },
          {
            name: this.$t("Sidebar.EAA.Marketing_Activities_Management.Name"),
            icon: "now-ui-icons business_chart-pie-36",
            path: "/",
            children: [
              {
                name: this.$t("Sidebar.EAA.Marketing_Activities_Management.Marketing_Activities_Overview"),
                icon: "el-icon-shopping-cart-full",
                path: "/eaa/business/promotions"
              },
              // {
              //   name: "行銷活動設定",
              //   icon: "el-icon-shopping-cart-full",
              //   path: "/eaa/business/promotions"
              // },
              // {
              //   name: "行銷活動報表",
              //   icon: "el-icon-shopping-cart-full",
              //   path: "/eaa/business/promotions"
              // }
            ]
          },
          // {
          //   name: this.$t("Sidebar.EAA.Login_Management.Name"),
          //   icon: "now-ui-icons users_single-02",
          //   path: "/",
          //   children: [
          //     {
          //       name: this.$t("Sidebar.EAA.Login_Management.Login_Record"),
          //       path: "/eaa-login-record"
          //     }
          //   ]
          // }
        ];
    }
  },
  mounted() {
    // 根據登入類型顯示sidebar
    console.log("test user type " + this.userType);
    switch (this.userType) {
      case "gaa":
        this.clickCounter();
        this.menu = this.generateGaaMenu();
        break;
      case "si":
        this.menu = this.generateSiMenu();
        break;
      case "eaa":
        this.menu = this.generateEaaMenu()
        break;
      case "line":
        this.menu = [
          {
            name: "營業概況",
            icon: "now-ui-icons business_chart-pie-36",
            path: "/summary",
            children: [
              {
                name: "圖表",
                path: "/summary/stat"
              },
              {
                name: "訂單列表",
                path: "/summary/orders"
              }
            ]
          },
          {
            name: "店家管理",
            icon: "now-ui-icons shopping_shop",
            path: "",
            children: [
              {
                name: "菜單管理",
                path: "/menu-management"
              }
            ]
          }
        ];
        break;
      default:
    }

    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");

    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
  },
  watch: {
    appLang: {
      handler(newVal, oldVal) {
        if (!newVal) return;
        // Recreate the menu data to achieve responsive i18n.
        switch (this.userType) {
          case "gaa":
            this.$set(this, "menu", this.generateGaaMenu())
            break;
          case "si":
            this.$set(this, "menu", this.generateSiMenu())
            break;
          case "eaa":
            this.$set(this, "menu", this.generateEaaMenu())
            break;
          case "line":
          default:
        }
      },
    },
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}

// Scroll-bar customization
/* width */
::-webkit-scrollbar {
  width: 6px;
}
/* Track */
::-webkit-scrollbar-track {
  // background: #f1f1f1; 
  background: transparent;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 3px;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
</style>
